module.exports = __webpack_public_path__ + "02_mole.481be1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/02_mole.png
// module id = vPv+
// module chunks = 0